import type { IAppStores } from "../shared-components/AppStores";
import type { IApp } from "../shared-components/App";

export interface IAppLegal extends IApp {
    stores: ILegalStores;
}

export class AppLegal implements IAppLegal {
    constructor(public readonly stores: ILegalStores) {}
}

export interface ILegalStores extends IAppStores {}
